export const organizations = [
  {
    id: 1001,
    name: "Reklambyrå Wilma",
    type: "Direkt kund",
    relation: "Direkt kund",
    network: "Wilma Production Network",
    parent: "—",
    billedBy: "—",
    owner: "Anna Andersson",
    lastActivity: "Idag 09:21",
    status: "Aktiv",
    city: "Stockholm",
  },
  {
    id: 1002,
    name: "Creative Partners",
    type: "Partner",
    relation: "Partner",
    network: "Wilma Production Network",
    parent: "Reklambyrå Wilma",
    billedBy: "Reklambyrå Wilma",
    owner: "Erik Karlsson",
    lastActivity: "Igår 16:40",
    status: "Aktiv",
    city: "Stockholm",
  },
  {
    id: 1003,
    name: "Freelance Sweden",
    type: "Partner",
    relation: "Partner",
    network: "Wilma Production Network",
    parent: "Creative Partners",
    billedBy: "Creative Partners",
    owner: "Maria Svensson",
    lastActivity: "2 jun 11:03",
    status: "Aktiv",
    city: "Göteborg",
  },
  {
    id: 1004,
    name: "Tryckeri Alfa",
    type: "Leverantör",
    relation: "Nätverksorganisation",
    network: "Wilma Production Network",
    parent: "Freelance Sweden",
    billedBy: "Freelance Sweden",
    owner: "Robert Liljen",
    lastActivity: "28 maj 15:12",
    status: "Aktiv",
    city: "Norrköping",
  },
  {
    id: 1005,
    name: "Tryckeri Beta",
    type: "Leverantör",
    relation: "Nätverksorganisation",
    network: "Wilma Production Network",
    parent: "Freelance Sweden",
    billedBy: "Freelance Sweden",
    owner: "Robert Liljen",
    lastActivity: "27 maj 10:04",
    status: "Aktiv",
    city: "Linköping",
  },
  {
    id: 1006,
    name: "Eventbolaget",
    type: "Direkt kund",
    relation: "Direkt kund",
    network: "Wilma Production Network",
    parent: "Event Partners",
    billedBy: "Event Partners",
    owner: "Anna Andersson",
    lastActivity: "24 maj 09:33",
    status: "Aktiv",
    city: "Malmö",
  },
  {
    id: 1007,
    name: "Design Agency Nord",
    type: "Prospekt",
    relation: "Prospekt",
    network: "Wilma Production Network",
    parent: "Creative Partners",
    billedBy: "Reklambyrå Wilma",
    owner: "Maria Svensson",
    lastActivity: "61 dagar",
    status: "Behöver uppföljning",
    city: "Umeå",
  },
  {
    id: 1008,
    name: "Profilprodukter AB",
    type: "Leverantör",
    relation: "Nätverksorganisation",
    network: "Wilma Production Network",
    parent: "Event Partners",
    billedBy: "Event Partners",
    owner: "Erik Karlsson",
    lastActivity: "55 dagar",
    status: "Behöver uppföljning",
    city: "Örebro",
  },
];

export const contacts = [
  { id: 1, name: "Anna Andersson", organization: "Reklambyrå Wilma", title: "Inköpschef", email: "anna@wilma.se", phone: "070-123 45 67", owner: "Robert Liljen", lastActivity: "Idag 09:21", status: "Aktiv" },
  { id: 2, name: "Johan Nilsson", organization: "Tryckeri Alfa", title: "Produktionschef", email: "johan@tryckerialfa.se", phone: "070-123 45 68", owner: "Maria Svensson", lastActivity: "Igår 16:42", status: "Aktiv" },
  { id: 3, name: "Sara Lindqvist", organization: "Creative Partners", title: "VD", email: "sara@creativepartners.se", phone: "070-123 45 69", owner: "Erik Karlsson", lastActivity: "Igår 14:15", status: "Aktiv" },
  { id: 4, name: "Erik Holm", organization: "Eventbolaget", title: "Projektledare", email: "erik@eventbolaget.se", phone: "070-123 45 70", owner: "Anna Andersson", lastActivity: "24 maj", status: "Aktiv" },
  { id: 5, name: "Lina Pettersson", organization: "Design Agency Nord", title: "AD", email: "lina@designnord.se", phone: "070-123 45 71", owner: "Maria Svensson", lastActivity: "61 dagar", status: "Behöver uppföljning" },
  { id: 6, name: "Mikael Berg", organization: "Profilprodukter AB", title: "Säljare", email: "mikael@profilprodukter.se", phone: "070-123 45 72", owner: "Erik Karlsson", lastActivity: "55 dagar", status: "Behöver uppföljning" },
];

export const activities = [
  { id: 1, type: "E-post", title: "Anna skickade prislista 2027", organization: "Reklambyrå Wilma", contact: "Anna Andersson", when: "Idag 10:42", status: "Klar" },
  { id: 2, type: "Samtal", title: "Telefonsamtal med Johan Nilsson", organization: "Tryckeri Alfa", contact: "Johan Nilsson", when: "Idag 09:15", status: "Klar" },
  { id: 3, type: "Uppgift", title: "Följ upp offert – Eventbolaget", organization: "Eventbolaget", contact: "Erik Holm", when: "Idag 11:00", status: "Öppen" },
  { id: 4, type: "Möte", title: "Avstämning – Creative Partners", organization: "Creative Partners", contact: "Sara Lindqvist", when: "Imorgon 09:00", status: "Planerad" },
  { id: 5, type: "Avtal", title: "Ramavtal 2026–2028 uppladdat", organization: "Freelance Sweden", contact: "—", when: "Igår 16:24", status: "Klar" },
  { id: 6, type: "Order", title: "Order #108654 skapad", organization: "Kommunal Syd", contact: "—", when: "8 aug 14:08", status: "Klar" },
  { id: 7, type: "Uppgift", title: "Skicka prislista – Test company 445", organization: "Test company 445", contact: "Erik Holm", when: "20 aug", status: "Öppen" },
];

export const deals = [
  { id: 1, name: "Ramavtal trycksaker 2027", organization: "Reklambyrå Wilma", stage: "Prospekt", value: 500000, probability: 20, owner: "Robert Liljen", closeDate: "2026-09-30", activity: "Idag 10:42" },
  { id: 2, name: "Årsavtal profilprodukter", organization: "Creative Partners", stage: "Kvalificering", value: 320000, probability: 35, owner: "Erik Karlsson", closeDate: "2026-09-15", activity: "Igår 16:40" },
  { id: 3, name: "Trycksaksproduktion Q4", organization: "Tryckeri Alfa", stage: "Offert", value: 210000, probability: 60, owner: "Robert Liljen", closeDate: "2026-08-31", activity: "28 maj" },
  { id: 4, name: "Eventproduktion höst", organization: "Eventbolaget", stage: "Förhandling", value: 140000, probability: 80, owner: "Anna Andersson", closeDate: "2026-08-25", activity: "24 maj" },
  { id: 5, name: "Designstöd lansering", organization: "Design Agency Nord", stage: "Vunnet", value: 78500, probability: 100, owner: "Maria Svensson", closeDate: "2026-08-10", activity: "10 aug" },
];

export const network = {
  id: 1,
  name: "Wilma Production Network",
  owner: "Reklambyrå Wilma",
  status: "Aktiv",
  organizations: 37,
  levels: 5,
  billedViaParent: 12,
  children: [
    {
      id: 1001,
      name: "Reklambyrå Wilma",
      role: "Huvudorganisation",
      relation: "Direkt kund",
      billedBy: "Direkt",
      children: [
        {
          id: 1002,
          name: "Creative Partners",
          role: "Partner",
          relation: "Partner",
          billedBy: "Reklambyrå Wilma",
          children: [
            {
              id: 1003,
              name: "Freelance Sweden",
              role: "Partner",
              relation: "Partner",
              billedBy: "Creative Partners",
              children: [
                { id: 1004, name: "Tryckeri Alfa", role: "Leverantör", relation: "Nätverksorganisation", billedBy: "Freelance Sweden", children: [] },
                { id: 1005, name: "Tryckeri Beta", role: "Leverantör", relation: "Nätverksorganisation", billedBy: "Freelance Sweden", children: [] },
                { id: 1010, name: "Efterbehandlare Delta", role: "Leverantör", relation: "Nätverksorganisation", billedBy: "Freelance Sweden", children: [] },
              ],
            },
            { id: 1007, name: "Design Agency Nord", role: "Partner", relation: "Partner", billedBy: "Reklambyrå Wilma", children: [] },
          ],
        },
        {
          id: 1011,
          name: "Event Partners",
          role: "Partner",
          relation: "Partner",
          billedBy: "Reklambyrå Wilma",
          children: [
            { id: 1006, name: "Eventbolaget", role: "Direkt kund", relation: "Direkt kund", billedBy: "Event Partners", children: [] },
            { id: 1008, name: "Profilprodukter AB", role: "Leverantör", relation: "Nätverksorganisation", billedBy: "Event Partners", children: [] },
          ],
        },
      ],
    },
  ],
};
